import { render, staticRenderFns } from "./D_MixologiaRed.vue?vue&type=template&id=23bedde9&scoped=true&"
import script from "./D_MixologiaRed.vue?vue&type=script&lang=js&"
export * from "./D_MixologiaRed.vue?vue&type=script&lang=js&"
import style0 from "./D_MixologiaRed.vue?vue&type=style&index=0&id=23bedde9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bedde9",
  null
  
)

export default component.exports